import { IStyle } from 'Styles';
import {
  BaseDriverPropertyDTO,
  BasePropertyDTO,
  IBaseDriverPropertyDTO,
} from 'business/models/Models';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import React, { useEffect } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { useGeneralDispensingProperties } from 'redux/hooks/generalDispensingProperties';
import { getGeneralDispensingPropertiesThunk } from 'redux/thunks/GeneralDispensingProperties';
import PropertyWrapper from './PropertyWrapper';
import { cloneDeep } from 'lodash';
import {
  setChangedDispensingProperties,
  setIsDirty,
} from 'redux/reducers/GeneralDispensingPropertiesReducer';
import RMTable from 'components/customComponents/Controls/RMTable';
import TableSortInputFilter from 'components/customComponents/Controls/tableSortInputFilter';
import { IGeneralDispensingPropertiesData } from './constants';
import {
  liquidClassColumnsData,
  liquidClassPropertiesData,
  plateColumnsData,
  platePropertiesData,
  setPropertyValue,
} from './utils';

const DispensingPropertiesDefinition = () => {
  const dispatch = useRMDispatch();

  const generalDispensingPropertiesData = useGeneralDispensingProperties();
  const generalDispensingProperties =
    generalDispensingPropertiesData.generalDispensingProperties;

  useEffect(() => {
    dispatch(getGeneralDispensingPropertiesThunk());
  }, []);

  const handleTableFilter = (filterable: boolean, filterTitle: string) => (event: any) =>
    (
      <TableSortInputFilter
        event={event}
        title={filterTitle}
        showSearchInput={filterable}
      />
    );

  const onChangeProp = (
    prop: BasePropertyDTO,
    e: any,
    robotId: number,
    plateId?: number,
    liquidClassId?: number,
  ) => {
    const property = cloneDeep(prop);

    setPropertyValue(property, e);

    const baseDriverPropertyDto: IBaseDriverPropertyDTO = new BaseDriverPropertyDTO();
    baseDriverPropertyDto.dispensingRobotId = robotId;
    baseDriverPropertyDto.dispensingPlateId = plateId;
    baseDriverPropertyDto.dispensingLiquidClassId = liquidClassId;
    baseDriverPropertyDto.property = property;

    dispatch(setChangedDispensingProperties(baseDriverPropertyDto));
    dispatch(setIsDirty(true));
  };

  const tabs: ITabItem[] = generateTabComponents(
    generalDispensingProperties,
    onChangeProp,
    handleTableFilter,
  );

  return (
    <>
      <div
        id="dispensingpropertiesdefinition-tabs-container"
        className="container-fluid p-0"
        style={styles.container}
      >
        <RMTabs
          tabItems={tabs}
          defaultActiveKey={tabs[0]?.eventKey}
          id={'robotsPropertiesTab'}
        />
      </div>
    </>
  );
};
const styles: IStyle = {
  container: {
    height: '100%',
  },
};
const generateTabComponents = (
  data: IGeneralDispensingPropertiesData,
  onChangeProp,
  handleTableFilter,
): ITabItem[] => {
  return data.robots.map((robot) => ({
    title: robot.name,
    eventKey: robot.name,
    content: (
      <div
        id="generatetabcomponents-container"
        style={{ display: 'flex', width: '100%' }}
      >
        <div
          id="generatetabcomponents-general-wrapper"
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '33%',
            padding: '10px',
            borderRight: '2px solid #ddd',
          }}
        >
          <div
            id="generatetabcomponents-general-title"
            style={{ fontWeight: 'bold', fontSize: '14px' }}
          >
            General
          </div>
          <div
            id="generatetabcomponents-general-properties"
            style={{ height: '69vh', overflow: 'auto' }}
          >
            <PropertyWrapper
              propertiesList={data.generalProperties[robot.id]}
              robotId={robot.id}
              onChangeProp={onChangeProp}
            />
          </div>
        </div>

        <div
          id="generatetabcomponents-platetype-wrapper"
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '33%',
            borderRight: '2px solid #ddd',
          }}
        >
          <div
            id="generatetabcomponents-platetype-title"
            style={{
              fontWeight: 'bold',
              fontSize: '14px',
              margin: '10px',
              borderBottom: '2px solid #ddd',
            }}
          >
            Plate Type
          </div>
          <div
            id="generatetabcomponents-platetype-table"
            style={{ height: '69vh', overflow: 'auto', padding: '10px' }}
          >
            <RMTable
              columns={plateColumnsData(handleTableFilter)}
              data={platePropertiesData(data, robot, onChangeProp)}
              tableClass="w-full"
            ></RMTable>
          </div>
        </div>

        <div
          id="generatetabcomponents-liquidclasses-wrapper"
          style={{ display: 'flex', flexDirection: 'column', width: '33%' }}
        >
          <div
            id="generatetabcomponents-liquidclasses-title"
            style={{
              fontWeight: 'bold',
              fontSize: '14px',
              margin: '10px',
              borderBottom: '2px solid #ddd',
            }}
          >
            Liquid Classes
          </div>
          <div
            id="generatetabcomponents-liquidclasses-table"
            style={{ height: '69vh', overflow: 'auto', padding: '10px' }}
          >
            <RMTable
              columns={liquidClassColumnsData(handleTableFilter)}
              data={liquidClassPropertiesData(data, robot, onChangeProp)}
              tableClass="w-full"
            ></RMTable>
          </div>
        </div>
      </div>
    ),
  }));
};
export default DispensingPropertiesDefinition;
